
import { AgentResponse, OrchestratorContext } from "../../Shared/types";
import { BACKEND_CONFIG } from "../config";
import { LocalAgentOrchestrator } from "./agentOrchestrator";

export class AgentServiceClient {
  private sessionId: string | null = null;
  private baseUrl: string = '/api/v1/agent';
  private localOrchestrator: LocalAgentOrchestrator | null = null;

  constructor() {
    // Persistent session ID for the user's browser session
    this.sessionId = localStorage.getItem('agent_session_id') || `session-${Date.now()}`;
    localStorage.setItem('agent_session_id', this.sessionId);
  }

  async processMessage(message: string, context: OrchestratorContext): Promise<AgentResponse> {
    if (!BACKEND_CONFIG.USE_EXTERNAL_BACKEND) {
       console.log("AgentServiceClient: Using Local Orchestrator");
       if (!this.localOrchestrator) {
         this.localOrchestrator = new LocalAgentOrchestrator(context);
       }
       return await this.localOrchestrator.processMessage(message);
    }

    const token = localStorage.getItem('auth_token');
    
    const response = await fetch(`${this.baseUrl}/orchestrate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      },
      body: JSON.stringify({
        message,
        context,
        sessionId: this.sessionId
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to communicate with the Agent Orchestrator');
    }

    const data = await response.json();
    return data.response;
  }

  clearSession() {
    this.sessionId = `session-${Date.now()}`;
    localStorage.setItem('agent_session_id', this.sessionId);
    this.localOrchestrator = null;
  }
}

export const agentServiceClient = new AgentServiceClient();
